<mat-form-field appearance="fill" class="no-assistive-text w-100" color="primary">
    <input
      [name]="name"
           matInput
           autocomplete="off"
           [readonly]="isRunningOnMobile || datePickerOpen"
           [matDatepicker]="picker"
           [placeholder]="placeholderText"
           [maxLength]="10"
           (click)="onInputClick()"
           [formControl]="currentFormControl"
    />
    <mat-error *ngIf="currentFormControl.invalid">
      <span *ngIf="currentFormControl.errors.required">Bitte geben Sie ein Geburtsdatum ein</span>
      <span *ngIf="currentFormControl.errors.maxDate">Der Interessent muss mindestens 18 Jahre alt sein</span>
    </mat-error>

    <button mat-icon-button
            matSuffix
            [class.hide]="!shouldShowClearButton()"
            aria-label="Löschen"
            (click)="clear(); $event.preventDefault()"
    >
        <mat-icon>clear</mat-icon>
    </button>

    <button
            mat-icon-button
            matSuffix
            aria-label="Auswählen"
            (click)="openDatepicker(); $event.preventDefault()"
    >
        <mat-icon>today</mat-icon>
    </button>

    <mat-datepicker #picker (closed)="closeDatepicker()"></mat-datepicker>

    <mat-label>{{ label }} <span *ngIf="!isRequired" class="grey-subtext">(optional)</span></mat-label>

</mat-form-field>
